<script lang="ts" setup>
import type { ApiMachineryPublicBaseSelect } from '~/layers/customer-module/types'

const props = defineProps<{ machinery?: ApiMachineryPublicBaseSelect | null, isLoading?: boolean }>()

const specialEquipmentsList = computed(() => {
  if (!props.machinery?.receptionMachinery) {
    return null
  }
  const receptionMachinery = props.machinery.receptionMachinery
  const customSpecialEquipments = receptionMachinery.customSpecialEquipment ? [receptionMachinery.customSpecialEquipment] : []

  const machinerySpecialEquipments = receptionMachinery.receptionMachinerySpecialEquipmentRelation?.receptionMachinerySpecialEquipments?.map(type => type.typeName) ?? []

  return customSpecialEquipments.concat(machinerySpecialEquipments).join(', ')
})
</script>

<template>
  <CustomerModuleDataCard :title="$t('customerModule.machinery.details.machinery.machineryEquipment')" :is-loading="isLoading">
    <div v-if="machinery" class="flex flex-col gap-2">
      <p class="font-semibold text-base">
        {{ $t('customerModule.machinery.details.machinery.machineryEquipmentColumn.accessories') }}
      </p>
      <div class="whitespace-pre-wrap text-base">
        {{ !machinery.marketingMachineryAccessoryDescription ? 'N/A' : machinery.marketingMachineryAccessoryDescription }}
      </div>

      <template v-if="specialEquipmentsList">
        <p class="font-semibold text-base">
          {{ $t('customerModule.machinery.details.machinery.specialEquipment') }}
        </p>
        <div class="whitespace-pre-wrap text-base">
          {{ specialEquipmentsList }}
        </div>
      </template>

      <p class="font-semibold text-base">
        {{ $t('customerModule.machinery.details.machinery.machineryEquipmentColumn.special') }}
      </p>
      <div class="whitespace-pre-wrap text-base">
        {{ !machinery.marketingSpecialEquipmentDescription ? 'N/A' : machinery.marketingSpecialEquipmentDescription }}
      </div>
    </div>
  </CustomerModuleDataCard>
</template>
